import { HttpClient } from '../HttpClient';
/**
 * * POST Job Request Approvals
 */
export const PostJobRequestApprovals = async (params) => {
  try {
    const { data } = await HttpClient.post('api/jobrequisitions/approvals', {...params});
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
